export default __webpack_public_path__ + "static/media/roadmap-head-shark-5.32c1acc9.png";